const EmptyUITestsIcon = (props) => (
  <span className="emptyUITestsIcon">
    <svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M85.3333 10.6667V85.3333H10.6667V10.6667H85.3333ZM85.3333 0H10.6667C4.8 0 0 4.8 0 10.6667V85.3333C0 91.2 4.8 96 10.6667 96H85.3333C91.2 96 96 91.2 96 85.3333V10.6667C96 4.8 91.2 0 85.3333 0ZM59.4133 47.2533L43.4133 67.8933L32 54.08L16 74.6667H80L59.4133 47.2533Z" fill="#111111" fillOpacity="0.2"/>
    </svg>
  </span>
)

export default EmptyUITestsIcon